import { alias } from '@ember/object/computed';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from 'ember-data-model-fragments/fragment';
export default EmberDataBaseFragment.extend({
  cards: fragmentArray('subscription-card'),
  payoutAdjustments: fragmentArray('subscription-bank-account'),
  banks: alias('payoutAdjustments')
});